export class SmsMessage {
  constructor({ to = null, body = null, orderID = 0 } = {}) {
    this.to = to;
    this.body = body;
    this.orderID = orderID;
  }
}
export function createNewSmsMessage(data) {
  return Object.freeze(new SmsMessage(data));
}
